import React, { Component } from 'react'
import UIAvatar from '../fragments/UIAvatar'
import './reportstyle.css'

class PdfPreviewer extends Component {

  render() {

    const { isModalOpen, loading, error, status, pdfBlob, pdfUrl, progress, reportTitle,
      handleDownload, handleClose, handlePreview
    } = this.props

    if (!isModalOpen) return null
    return (
      <div className="pdf-modal-overlay">
        <div className="pdf-modal-header">
          <span className="pdf-modal-title">
            <UIAvatar name={ reportTitle } size={ 22 } />&nbsp; 
            Report Preview: { reportTitle }
          </span>
          <div className="pdf-modal-actions">
            <button
              className="pdf-icon-btn"
              onClick={ handleDownload }
              disabled={!pdfBlob}
              title="Download PDF"
            >
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
                <polyline points="7 10 12 15 17 10"/>
                <line x1="12" y1="15" x2="12" y2="3"/>
              </svg>
            </button>
            <button
              className="pdf-icon-btn"
              onClick={ handleClose }
              title="Close (ESC)"
            >
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <line x1="18" y1="6" x2="6" y2="18"/>
                <line x1="6" y1="6" x2="18" y2="18"/>
              </svg>
            </button>
          </div>
        </div>

        <div className="progress-bar-container">
          <div
            className="progress-bar-fill"
            style={{ width: `${progress}%` }}
          />
        </div>

        <div className="pdf-modal-content">
          {loading && (
            <div className="pdf-loading-container">
              <div className="spinner"></div>
              <span className="loading-text">Loading report...</span>
            </div>
          )}

          {!loading && error && (
            <div className="pdf-error-container">
              <div className="pdf-error-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <circle cx="12" cy="12" r="10"/>
                  <line x1="12" y1="8" x2="12" y2="12"/>
                  <line x1="12" y1="16" x2="12.01" y2="16"/>
                </svg>
              </div>
              <span className="pdf-error-title">Failed to load report</span>
              <span className="pdf-error-message">
                {error || 'An unexpected error occurred while fetching the report.'}
              </span>
              {status && (
                <span className="pdf-error-status">Status: {status}</span>
              )}
              <button className="pdf-retry-btn" onClick={ handlePreview }>
                Try Again
              </button>
            </div>
          )}

          {!loading && !error && pdfUrl && (
            <iframe
              className="pdf-viewer"
              src={ pdfUrl }
              title={ reportTitle }
            />
          )}
        </div>
      </div>
    )
  }
}

export default PdfPreviewer



// WEBPACK FOOTER //
// ./src/components/Reports/PdfPreviewer.js